<template>
  <div class="view">
    <div class="view__inner">
      <div class="text-center m-b-1">
        <SVGLogo class="view__logo" />
      </div>

      <el-alert :title="alert.title" :type="alert.type" :description="alert.description" show-icon :closable="false"> </el-alert>

      <div v-show="isLoading" class="m-t-2">
        <p v-loading="isLoading">&nbsp;</p>

        <p class="text-center m-t-1">Bitte warten...</p>
      </div>

      <Separator class="m-t-2" :show-line="true"></Separator>

      <p class="text-center m-t-2">
        <router-link :to="{ path: '/login' }" tag="el-button" class="w-100">
          {{ $t('Login') }}
        </router-link>
      </p>
    </div>

    <!-- Footer -->
    <p class="view__footer">
      <a href="https://gpal.epal-pallets.org/menus/menu-marginal/impressum/" target="_blank" :title="$t('Imprint')" class="color-brand">{{
        $t('Imprint')
      }}</a>
    </p>
  </div>
</template>

<script>
import * as Articles from '@/services/bb_articles';
import { get } from 'lodash';
import Separator from '@/components/Misc/Separator';
import SVGLogo from '@/assets/img/epal-deutschland-black.svg';

export default {
  name: 'PublishArticle',

  components: {
    Separator,
    SVGLogo
  },

  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },

  data() {
    return {
      alert: {
        type: 'info',
        description: 'Der Artikel wird manuell freigegeben.',
        title: 'Bitte warten'
      },
      isLoading: true
    };
  },

  async mounted() {
    console.log(this.uuid);
    // Make a request to the backend with the current uuid
    this.init();
  },

  methods: {
    async init() {
      try {
        this.isLoading = true;
        const response = await Articles.publishArticleByUuid(this.uuid);
        this.isLoading = false;

        const data = get(response, 'data');
        const error = get(response, 'error');
        const message = get(response, 'error.message');

        if (error && message) {
          this.alert.type = 'error';
          this.alert.title = this.$t('Error');
          this.alert.description = message;
        }

        if (data) {
          this.alert.type = 'success';
          this.alert.title = this.$t('Erfolg');
          this.alert.description = this.$t('Article has been published successfully');
        }
      } catch (error) {
        this.isLoading = false;
        const message = get(error, 'message');

        if (message) {
          this.alert.type = 'error';
          this.alert.title = this.$t('Error');
          this.alert.description = message;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
